import React, { useState, useCallback } from "react";

const InputField = ({ type, name, placeholder, value, onChange, error }) => (
  <div>
    <input
      type={type}
      name={name}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      className={`w-full px-4 py-2 border ${
        error ? "border-red-500" : "border-gray-300"
      } rounded-md focus:outline-none focus:ring-2 focus:ring-red-500`}
      required
    />
    {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
  </div>
);

const QuoteSection = () => {
  const [formData, setFormData] = useState({
    formType: "contact",
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [errors, setErrors] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const validateForm = () => {
    let isValid = true;
    let newErrors = { name: "", email: "", phone: "", message: "" };

    if (!/^[a-zA-Z\s]+$/.test(formData.name)) {
      newErrors.name = "Name must contain only letters and spaces.";
      isValid = false;
    }

    if (!/^\S+@\S+\.\S+$/.test(formData.email)) {
      newErrors.email = "Enter a valid email address.";
      isValid = false;
    }

    if (!/^\d{10}$/.test(formData.phone)) {
      newErrors.phone = "Phone number must be exactly 10 digits.";
      isValid = false;
    }

    if (!formData.message.trim()) {
      newErrors.message = "Message is required.";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const apiUrl = process.env.REACT_APP_API_URL || "http://localhost:5000";

  const handleSubmit = useCallback(
    async (e) => {
      e.preventDefault();
      if (!validateForm()) return;

      try {
        console.log("Submitting form:", formData);

        const response = await fetch(`${apiUrl}/submit`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        });

        if (!response.ok) {
          const errorText = await response.text();
          console.error("Failed response:", errorText);
          alert(`Failed to submit the form. Error: ${errorText}`);
          return;
        }

        alert("Form submitted successfully!");
        setFormData({ formType: "contact", name: "", email: "", phone: "", message: "" });
        setErrors({ name: "", email: "", phone: "", message: "" });
      } catch (error) {
        console.error("Error submitting the form:", error);
        alert("An error occurred. Please try again.");
      }
    },
    [formData, apiUrl]
  );

  return (
    <div className="bg-primary py-12">
      <div className="container mx-auto px-12">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <div className="w-full md:w-6/7">
            <h2 className="text-3xl font-bold text-white mb-4">
              Empowering Industries with Advanced Wireless Technologies
            </h2>
            <div className="w-16 h-1 bg-secondary mb-4"></div>
            <p className="text-white text-md mb-6">
              Welcome to Pixel Innovative Solutions, your trusted partner in
              Industrial Solutions. Established in 2023, we specialize in
              providing innovative products and solutions that address the unique
              needs of modern industries.
            </p>
            <a href="/about">
              <button className="bg-secondary rounded-md text-white px-6 py-2 shadow-md hover:bg-white hover:text-primary">
                Know More
              </button>
            </a>
          </div>

          <div className="w-full md:w-3/10 flex justify-center">
            <form
              className="space-y-4 p-6 shadow-md rounded-md bg-white w-full max-w-sm quote-form"
              onSubmit={handleSubmit}
            >
              <h3 className="text-2xl text-primary font-bold">
                Get Your Quote <span className="text-secondary">Today!</span>
              </h3>

              <InputField
                type="text"
                name="name"
                placeholder="Full Name*"
                value={formData.name}
                onChange={handleChange}
                error={errors.name}
              />
              <InputField
                type="email"
                name="email"
                placeholder="Email*"
                value={formData.email}
                onChange={handleChange}
                error={errors.email}
              />
              <InputField
                type="tel"
                name="phone"
                placeholder="Mobile Number*"
                value={formData.phone}
                onChange={handleChange}
                error={errors.phone}
              />
              <textarea
                name="message"
                placeholder="Requirement*"
                value={formData.message}
                onChange={handleChange}
                rows="3"
                className={`w-full px-4 py-2 border ${
                  errors.message ? "border-red-500" : "border-gray-300"
                } rounded-md focus:outline-none focus:ring-2 focus:ring-red-500`}
                required
              ></textarea>
              {errors.message && <p className="text-red-500 text-sm mt-1">{errors.message}</p>}

              <button
                type="submit"
                className="w-full bg-secondary text-white py-2 rounded-md shadow-md hover:bg-primary"
              >
                Submit
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuoteSection;
